import { render, staticRenderFns } from "./CreateFormModal.vue?vue&type=template&id=d935b1c2&scoped=true&"
import script from "./CreateFormModal.vue?vue&type=script&lang=js&"
export * from "./CreateFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d935b1c2",
  null
  
)

export default component.exports